import dayjs from 'dayjs';
import type { TDocumentDefinitions } from 'pdfmake/interfaces';
import { Timestamp } from 'firebase/firestore';
import { Application } from '../models';

function transformDate(date: Date | Timestamp): string {
  if (date instanceof Date) {
    return dayjs(date).format('MM/DD/YYYY');
  }
  if (date instanceof Timestamp) {
    return dayjs(date.toDate()).format('MM/DD/YYYY');
  }
  return 'N/A';
}

export function generateDocumentDefinition(application: Application): TDocumentDefinitions {
  const dd = {
    pageSize: 'LETTER',
    content: [
      {
        layout: 'noBorders',
        table: {
          widths: ['*', '*', '*'],
          body: [
            [
              {
                colSpan: 3,
                text: 'Scholarship Selection',
                style: 'sectionHeader',
                margin: [0, 16, 0, 16],
              },
              {},
              {},
            ],
            [
              {
                text: [
                  {
                    text: 'Scholarship Category\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.category ?? 'N/A'}`,
                  },
                ],
              },
              {
                text: [
                  {
                    text: 'Start Date\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: transformDate(application?.startDate),
                  },
                ],
              },
              {
                text: [
                  {
                    text: 'Finish Date\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: transformDate(application?.lastUpdated),
                  },
                ],
              },
            ],
            [
              {
                colSpan: 3,
                text: 'Contact Information',
                style: 'sectionHeader',
                margin: [0, 16, 0, 16],
              },
              {},
              {},
            ],
            [
              {
                text: [
                  {
                    text: 'Fist name\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.applicant?.firstName ?? 'N/A'}`,
                  },
                ],
              },
              {
                text: [
                  {
                    text: 'Middle name\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.applicant?.middleName ?? 'N/A'}`,
                  },
                ],
              },
              {
                text: [
                  {
                    text: 'Last name\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.applicant?.surname ?? 'N/A'}`,
                  },
                ],
              },
            ],
            [
              {
                text: [
                  {
                    text: 'Gender\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.applicant?.gender ?? 'N/A'}`,
                  },
                ],
              },
              {
                text: [
                  {
                    text: 'Birth date\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.applicant?.birthDate ?? 'N/A'}`,
                  },
                ],
              },
              {
                text: [
                  {
                    text: 'Nationality\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.applicant?.nationality ?? 'N/A'}`,
                  },
                ],
              },
            ],
            [
              {
                text: [
                  {
                    text: 'Parish of birth\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.applicant?.parish ?? 'N/A'}`,
                  },
                ],
              },
              {
                text: [
                  {
                    text: 'Address\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.applicant?.address ?? 'N/A'}`,
                  },
                ],
              },
              {
                text: [
                  {
                    text: 'Mailing Address\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.applicant?.mailingAddress ?? 'N/A'}`,
                  },
                ],
              },
            ],
            [
              {
                text: [
                  {
                    text: 'Home phone\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.applicant?.homePhone ?? 'N/A'}`,
                  },
                ],
              },
              {
                text: [
                  {
                    text: 'Cellphone\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.applicant?.cellphone ?? 'N/A'}`,
                  },
                ],
              },
              {
                text: [
                  {
                    text: 'Email\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.applicant?.email ?? 'N/A'}`,
                  },
                ],
              },
            ],
            [
              {
                colSpan: 3,
                text: 'Education',
                style: 'sectionHeader',
                margin: [0, 16, 0, 16],
                pageBreak: 'before',
              },
              {},
              {},
            ],
            [
              {
                text: [
                  {
                    text: 'High School Attended\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.education?.highSchool ?? 'N/A'}`,
                  },
                ],
              },
              {
                text: [
                  {
                    text: 'Year of High School Graduation\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.education?.year ?? 'N/A'}`,
                  },
                ],
              },
              {
                text: [
                  {
                    text: 'Are you a first-generation college student?\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${
                      (application?.education?.firstGeneration ?? 'off') ===
                      'off'
                        ? 'Yes'
                        : 'No'
                    }`,
                  },
                ],
              },
            ],
            ...(application?.education?.qualifications?.length > 0
              ? [
                  [
                    {
                      colSpan: 3,

                      layout: 'noBorders',
                      table: {
                        widths: ['*', '*', '*', '*', '*'],
                        body: [
                          [
                            { text: 'Qualifications', bold: true },
                            { text: 'Type', bold: true },
                            { text: 'Institution', bold: true },
                            { text: 'Duration', bold: true },
                            { text: 'Completed', bold: true },
                          ],
                          ...(application?.education?.qualifications?.map(
                            (q) => [
                              { text: `${q?.name ?? ''}` },
                              { text: `${q?.type ?? ''}` },
                              { text: `${q?.institution ?? ''}` },
                              { text: `${q?.duration ?? ''}` },
                              { text: `${q?.completed ?? ''}` },
                            ]
                          ) ?? []),
                        ],
                      },
                    },
                    {},
                    {},
                  ],
                ]
              : []),
            [
              {
                colSpan: 3,
                text: 'Details of Programme',
                style: 'sectionHeader',
                margin: [0, 16, 0, 16],
              },
              {},
              {},
            ],
            [
              {
                text: [
                  {
                    text: 'Name institute\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.program?.institute ?? 'N/A'}`,
                  },
                ],
              },
              {
                text: [
                  {
                    text: 'Course of study\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.program?.major ?? 'N/A'}`,
                  },
                ],
              },
              {
                text: [
                  {
                    text: 'Duration of Study\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.program?.duration ?? 'N/A'}`,
                  },
                ],
              },
            ],
            [
              {
                text: [
                  {
                    text: 'Academic status\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.program?.seniority ?? 'N/A'}`,
                  },
                ],
              },
              {
                text: [
                  {
                    text: 'Recent cumulative GPA\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.program?.gpa ?? 'N/A'}`,
                  },
                ],
              },
              {
                text: [
                  {
                    text: 'Previously Scholarship\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${
                      application?.program?.previousScholarship ?? 'N/A'
                    }`,
                  },
                ],
              },
            ],
            [
              {
                colSpan: 3,
                text: [
                  {
                    text: 'Details\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.program?.details ?? 'N/A'}`,
                  },
                ],
              },
              {},
              {},
            ],
            [
              {
                colSpan: 3,
                text: 'Essays',
                style: 'sectionHeader',
                margin: [0, 16, 0, 16],
                pageBreak: 'before',
              },
              {},
              {},
            ],
            [
              {
                colSpan: 3,
                text: [
                  {
                    text: 'Reason for applying for a Carreras scholarship\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.essay?.reason ?? 'N/A'}`,
                  },
                ],
              },
              {},
              {},
            ],
            [
              {
                colSpan: 3,
                text: [
                  {
                    text: 'Financial constraints\n',
                    style: 'header',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: `${application?.essay?.financial ?? 'N/A'}`,
                  },
                ],
              },
              {},
              {},
            ],
            [
              {
                colSpan: 3,
                text: 'Leadership and Volunteerism',
                style: 'sectionHeader',
                margin: [0, 16, 0, 16],
              },
              {},
              {},
            ],
            ...(application?.volunteering?.leadership?.length > 0
              ? [
                  [
                    {
                      colSpan: 3,
                      margin: [0, 8],
                      // layout: 'noBorders',
                      table: {
                        widths: ['*', 'auto'],
                        body: [
                          [
                            {
                              text: 'Leadership position / office',
                              bold: true,
                            },
                            { text: 'Year', bold: true },
                          ],
                          ...(application?.volunteering?.leadership?.map(
                            (l) => [
                              {
                                text: l.name,
                              },
                              { text: l.year },
                            ]
                          ) ?? []),
                        ],
                      },
                    },
                    {},
                    {},
                  ],
                ]
              : []),
            ...(application?.volunteering?.clubs?.length > 0
              ? [
                  [
                    {
                      colSpan: 3,
                      margin: [0, 8],
                      // layout: 'noBorders',
                      table: {
                        widths: ['*', 'auto'],
                        body: [
                          [
                            { text: 'Club / Society', bold: true },
                            { text: 'Year', bold: true },
                          ],
                          ...(application?.volunteering?.clubs?.map((c) => [
                            {
                              text: c.name,
                            },
                            { text: c.year },
                          ]) ?? []),
                        ],
                      },
                    },
                    {},
                    {},
                  ],
                ]
              : []),
            ...(application?.volunteering?.services?.length > 0
              ? [
                  [
                    {
                      colSpan: 3,
                      margin: [0, 8],
                      // layout: 'noBorders',
                      table: {
                        widths: ['*', 'auto'],
                        body: [
                          [
                            { text: 'Services', bold: true },
                            { text: 'Date', bold: true },
                          ],
                          ...(application?.volunteering?.services?.map((s) => [
                            {
                              text: s.service,
                            },
                            {
                              text: s.date,
                            },
                          ]) ?? []),
                        ],
                      },
                    },
                    {},
                    {},
                  ],
                ]
              : []),
            [
              {
                colSpan: 3,
                text: 'References',
                style: 'sectionHeader',
                margin: [0, 16, 0, 16],
                pageBreak: 'before',
              },
              {},
              {},
            ],
            ...(application?.people
              ?.map((person, idx) => [
                [
                  {
                    colSpan: 3,
                    text: `Person ${idx + 1}`,
                    style: 'header',
                    bold: true,
                    margin: [0, 0, 0, 8],
                  },
                  {},
                  {},
                ],
                [
                  {
                    text: [
                      {
                        text: 'Name\n',
                        style: 'header',
                        margin: [0, 0, 0, 4],
                      },
                      {
                        text: `${person?.name ?? 'N/A'}`,
                      },
                    ],
                  },
                  {
                    text: [
                      {
                        text: 'Position\n',
                        style: 'header',
                        margin: [0, 0, 0, 4],
                      },
                      {
                        text: `${person?.position ?? 'N/A'}`,
                      },
                    ],
                  },
                  {
                    text: [
                      {
                        text: 'Institution\n',
                        style: 'header',
                        margin: [0, 0, 0, 4],
                      },
                      {
                        text: `${person?.institution ?? 'N/A'}`,
                      },
                    ],
                  },
                ],
                [
                  {
                    colSpan: 2,
                    text: [
                      {
                        text: 'Address\n',
                        style: 'header',
                        margin: [0, 0, 0, 4],
                      },
                      {
                        text: `${person?.address ?? 'N/A'}`,
                      },
                    ],
                  },
                  {},
                  {
                    text: [
                      {
                        text: 'Phone\n',
                        style: 'header',
                        margin: [0, 0, 0, 4],
                      },
                      {
                        text: `${person?.phone ?? 'N/A'}`,
                      },
                    ],
                  },
                ],
              ])
              ?.flat(1) ?? []),
          ],
        },
      },
    ],
    defaultStyle: {
      fontSize: 12,
      color: '#1c1c1c',
    },
    styles: {
      sectionHeader: {
        fontSize: 15,
        bold: true,
        alignment: 'center',
        color: '#111111',
        // margin: [0, 16],
      },
      header: {
        fontSize: 10,
        italics: true,
        alignment: 'left',
        color: '#333333',
      },
    },
  };
  return dd as TDocumentDefinitions;
}
